import axios from "axios";

export const request = axios.create({
  baseURL: "https://app.2gethr.xyz/api/v1",
  // baseURL: "http://localhost:5000/api/v1",
  withCredentials: false,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
});

export const handleErrors = (error) => {
  if (error.response && error.response.status === 404) {
    return "Something went wrong";
  }

  if (error.response) {
    /*
     * The request was made and the server responded with a
     * status code that falls out of the range of 2xx
     */
    return (
      (error &&
        error.response &&
        error.response.data &&
        error.response.data.message) ||
      (error &&
        error.response &&
        error.response.data &&
        error.response.data.error)
    );
  }
  if (error.request) {
    /*
     * The request was made but no response was received, `error.request`
     * is an instance of XMLHttpRequest in the browser and an instance
     * of http.ClientRequest in Node.js
     */
    return "Something went wrong.";
  }
  // Something happened in setting up the request and triggered an Error
  return error.message;
};

export const deleteKeyFromObject = (obj, key) => {
  const new_ = { ...obj };
  delete new_[key];
  return { ...new_ };

  // const filtered = Object.keys(obj)
  // .filter(key => !allowed.includes(key))
  // .reduce((obj, key) => {
  //   obj[key] = raw[key];
  //   return obj;
  // }, {});

  // return Object.keys(obj).reduce((acc, value) => {
  //   if (String(value) !== key) {
  //     acc[value] = obj[value];
  //   }
  //   return acc;
  // }, {});
};

export const fakePromise = (duration = 3000) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve("take them vals");
    }, duration);
  });
};

export const convertToInputDate = (date) => {
  let date_ = new Date(date);
  let day = ("0" + date_.getDate()).slice(-2);
  let month = ("0" + (date_.getMonth() + 1)).slice(-2);
  let formattedDate = date_.getFullYear() + "-" + month + "-" + day;
  return formattedDate;
};

// object to query string conversion
export const toQueryString = (params) =>
  Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
